import React, { useState, useEffect } from "react";
import { Grid, FormLabel, RadioGroup, FormControlLabel, Radio } from "@material-ui/core";
import { Option } from "../FormSelect";
import { useStyles } from "src/styles/RadioButtonStyles";

type RadioButtonProps = {
    defaultValue: any,
    label: string,
    options: Array<Option>,
    onCheck: (value:string) => void  
}

/**
 * This is a re-usable Component. Provides the radio button groups with a label. 
 */
const RadioButton : React.FunctionComponent<RadioButtonProps>  = (props: RadioButtonProps) => {
    const styles = useStyles();
    const[checkedValue, setCheckedValue] = useState(props.defaultValue);

    useEffect(() => { 
        setCheckedValue(props.defaultValue);
     },[props.defaultValue]);

    const handleChange= (event: React.ChangeEvent<any>) => {
        setCheckedValue(event.target.value);
        props.onCheck(event.target.value);    
    }

    const listOfOptions = props.options.map((option) => (
        <FormControlLabel 
            className={styles.radioButton} 
            key={option.name}
            value={option.value} 
            disabled={option.disabled} 
            control={<Radio />} 
            label={option.name} />
    ));

    return ( 
        <Grid 
            container
            alignItems="center"  
            spacing={1}>
            <Grid item>
                <FormLabel className={styles.label}>{props.label}</FormLabel>
            </Grid>
            <Grid item>
                <RadioGroup
                    className={styles.radioButtonGroup}
                    row
                    value={checkedValue}
                    onChange={handleChange}>
                    {listOfOptions}
                </RadioGroup>    
            </Grid>
        </Grid>
    );
}

export default RadioButton;
